document.addEventListener("DOMContentLoaded", () => {
  
    async function loadProductVariants(productHandle) {
      const selectElement = document.querySelector("#pdpBundleSelector");
      
      if (productHandle && selectElement) {
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          if (!response.ok) throw new Error("Error");
  
          const productData = await response.json();
          const variants = productData.variants;

          selectElement.innerHTML = '<option value="">SELECT SIZE</option>';
    
          variants.forEach((variant) => {
            if (variant.available) {
                const option = document.createElement("option");
                option.value = variant.id;
                option.textContent = "Size " + variant.option2;
                selectElement.appendChild(option);
                selectElement.setAttribute('style', 'background-color: #A1A1A1;');
            }
          });

          fetch(`/products/${productHandle}`)
          .then(response => response.text())
          .then(html => {
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = html;

            const productJsonElement = tempContainer.querySelector('[data-product-json]');
            if (productJsonElement) {
              try {
                const productData = JSON.parse(productJsonElement.innerHTML);
                const inventories = productData.inventories;

                const options = pdpBundleSelector.querySelectorAll('option');
                options.forEach(option => {
                  const optionValue = option.value;

                  if (inventories[optionValue]) {
                    const inventory = inventories[optionValue];

                    if (
                      inventory['inventory_management'] !== null &&
                      inventory['inventory_quantity'] - (inventory['preorder-limit'] || 0) <= 0 &&
                      inventory['preorder-date'] !== null
                    ) {
                      option.setAttribute('data-preorder-message', inventory['preorder-date']);
                    }
                  }
                });
              } catch (error) {
                console.error('Error parsing JSON:', error);
              }
            } else {
              console.error('Element data-product-json not found');
            }
          })
          .catch(error => console.error('Error loading PDP:', error));
    
        } catch (error) {
          console.error("Error", error);
        }
      }
    }

    function checkATCButton() {
        const bundleVariantElement = document.querySelector("#bundleCurrentProductVariant");
        const selectorElement = document.querySelector("#pdpBundleSelector");
        const atcButton = document.querySelector("#pdpBundleAtc");
    
        const bundleVariantId = bundleVariantElement?.getAttribute("data-bundle-id");
        const selectedVariantId = selectorElement?.value;
    
        const currentProductPrice = parseFloat(bundleVariantElement?.getAttribute("data-current-product-price")) || null;
        const selectedProductPrice = parseFloat(document.querySelector("#pdpBundleProductSwatch")?.getAttribute("data-selected-product-price")) || null;
    
        if (bundleVariantId && selectedVariantId) {
          if (currentProductPrice !== null && selectedProductPrice !== null) {
            const crossedOutPrice = ((currentProductPrice + selectedProductPrice) / 100);
            //const discountedPrice = ((currentProductPrice + 0.5 * selectedProductPrice) / 100);
            //const discountedPrice = ((currentProductPrice + selectedProductPrice) / 100) - 10;
            const discountedPrice = crossedOutPrice - 10;
            
            atcButton.innerHTML = `ADD BUNDLE TO BAG - $${discountedPrice} <s><em>$${crossedOutPrice}</em></s>`;
          } else {
            atcButton.innerHTML = "ADD BUNDLE TO BAG";
          }
    
          atcButton.removeAttribute('disabled');
        } else {
          atcButton.innerHTML = "SELECT SIZE";
          atcButton.setAttribute('disabled', 'disabled');
        }
    }
    
    function addToCart() {
      const bundleVariantElement = document.querySelector("#bundleCurrentProductVariant");
      const selectorElement = document.querySelector("#pdpBundleSelector");
    
      const bundleVariantId = bundleVariantElement?.getAttribute("data-bundle-id");
      const selectedVariantId = selectorElement?.value;
    
      if (bundleVariantId && selectedVariantId) {
        const selectedOption = selectorElement.options[selectorElement.selectedIndex];
        
        let estimatedShippingDate = null;
        if (selectedOption.hasAttribute('data-preorder-message')) {
          estimatedShippingDate = selectedOption.getAttribute('data-preorder-message');
        }
    
        const items = [
          { id: bundleVariantId, quantity: 1 }
        ];
    
        const selectedItem = {
          id: selectedVariantId,
          quantity: 1
        };
    
        if (estimatedShippingDate) {
          selectedItem.properties = { 'Estimated Shipping Date': estimatedShippingDate };
        }
    
        items.push(selectedItem);
    
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) throw new Error("Error adding items to cart");
          return response.json();
        })
        .then(data => {
          const event = new CustomEvent('product:added', {
            detail: {
              quantity: 2
            }
          });
          document.dispatchEvent(event);
        })
        .catch(error => {
          console.error("Error:", error);
        });
      }
    }
    
    const initialProductHandle = document.querySelector("#pdpBundleProductSwatch")?.getAttribute("data-selected-product");

    if (initialProductHandle) loadProductVariants(initialProductHandle);
    
    const swatchElements = document.querySelectorAll(".pdp_bundle-product-swatch");
    
    //swatchElements.forEach((swatch) => {
      $("#product-section").on('click', ".pdp_bundle-product-swatch", function(event) {
      //swatch.addEventListener("click", (event) => {
        const productHandle = event.currentTarget.getAttribute("data-product-handle");
        document.querySelector("#pdpBundleProductSwatch").setAttribute("data-selected-product", productHandle);
        loadProductVariants(productHandle);
        swatchElements.forEach(swatch => {
            $(this).parent().remove('active');
        })
        $(this).parent().add('active');
        const preorderMsg = document.querySelector('.product-bundle-preorder-msg');
        preorderMsg.innerHTML = ''
        setTimeout(() => {
          checkATCButton();
        }, 500);
      });
    //});

    checkATCButton();

    $("#product-section").on('change', '#pdpBundleSelector', function(event) {
    //document.querySelector("#pdpBundleSelector").addEventListener("change", (event) => {
        checkATCButton();
        if(event.target.value == '') {
            event.target.setAttribute('style', 'background-color: #A1A1A1;')
        } else {
            event.target.setAttribute('style', 'background-color: #1f4477;')
        }

        const selectedOption = event.target.options[event.target.selectedIndex]; 
        const preorderMsg = document.querySelector('.product-bundle-preorder-msg');

        if (selectedOption.hasAttribute('data-preorder-message')) {
          preorderMsg.innerHTML = 'Pre order'
        } else {
          preorderMsg.innerHTML = ''
        }
    });

    $("#product-section").on('click', '#pdpBundleAtc', function(event) {
      //document.querySelector("#pdpBundleAtc").addEventListener("click", () => {
        checkATCButton();
        const atcButton = document.querySelector("#pdpBundleAtc");
        if (atcButton.getAttribute('disabled') != 'disabled') {
            addToCart();
        }
    });

});